import { ImageViewer } from "./ImageViewer";
import { ZoomableImage } from "./ZoomableImage";
import styled from "styled-components";
import { Image } from "../types/images";

interface MobileImageViewerProps {
  images: Image[];
  isOpen: boolean;
  onClose: () => void;
}

const MobileViewerWrapper = styled.div`
  .theatre__content-wrapper {
    overflow: hidden !important;
  }
`;

const MobileImageContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: calc(85vh - 110px);
  pointer-events: none;
  overflow: hidden;

  /* Re-enable pointer events for child elements */
  & > * {
    pointer-events: auto;
  }
`;

const MobileZoomableImage = styled(ZoomableImage)`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
`;

export const MobileImageViewer = ({
  images,
  isOpen,
  onClose,
}: MobileImageViewerProps) => {
  return (
    <MobileViewerWrapper>
      <ImageViewer
        images={images}
        isOpen={isOpen}
        onClose={onClose}
        carouselId="mobileImageViewer"
        ZoomableImageComponent={MobileZoomableImage}
        renderWrapper={(imageElement, key) => (
          <MobileImageContainer key={key}>{imageElement}</MobileImageContainer>
        )}
      />
    </MobileViewerWrapper>
  );
};
